import { spaceCadet } from '@cogneed/react-utils';
import { Dialog, styled } from '@mui/material';
import { scrollbarStyle1 } from '../../../../../styles/scrollbarStyles';
import PageLayout from '../../../../Layouts/PageLayout';

export const StyledLayout = styled(PageLayout)({
  '& .MuiBox-root.content': {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    '& > .MuiBox-root.info': {
      ...scrollbarStyle1,
      overflow: 'auto',
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
    },
    '& > .MuiBox-root.request': {
      border: 'none',
      padding: 0,
    },
  },
});

const StyledDialog = styled(Dialog)({
  '& > .MuiPaper-root': {
    maxHeight: 800,
    minHeight: 400,
  },
  '& .MuiDialogContent-root': {
    padding: 0,
    display: 'flex',
    flexDirection: 'column',

    '& > .MuiButtonBase-root': {
      position: 'absolute',
      right: 0,
      color: spaceCadet[500],
      padding: 8,
      minWidth: 0,
      '&:hover': {
        backgroundColor: spaceCadet[100],
      },
      '& svg': {
        fontSize: 18,
      },
    },
  },
});

export default StyledDialog;
